(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__claerHeroParallaxInit) return;
    window.__claerHeroParallaxInit = true;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return;

    var LERP = 0.08; // smoothing factor — lower = more trailing/buttery, higher = snappier
    var MEDIA_SCALE = 1.3; // must match the CSS scale() so the drift clamp stays safe

    var state = new Map(); // el -> { media, content, opacity }
    var rafId = null;

    function getEls() {
      return Array.prototype.slice.call(document.querySelectorAll('.hero--parallax[data-parallax="true"]'));
    }

    function targetsFor(el) {
      var rect = el.getBoundingClientRect();
      var progress = Math.min(Math.max(-rect.top / rect.height, 0), 1);

      var strength = parseFloat(el.dataset.parallaxStrength);
      if (isNaN(strength)) strength = 0.15;

      // Image drift stays within the headroom the 1.3x scale provides,
      // however high "strength" is pushed.
      var headroom = rect.height * (MEDIA_SCALE - 1) / 2 * 0.85;
      var mediaDrift = Math.min(rect.height * 0.35 * strength, headroom);

      // Text drifts further and fades out faster than the image, so it
      // recedes while the image stays put — the layered "depth" effect.
      var contentDrift = mediaDrift * 1.8;
      var opacity = Math.max(0, 1 - progress * 1.6);

      return {
        media: -progress * mediaDrift,
        content: -progress * contentDrift,
        opacity: opacity
      };
    }

    function tick() {
      rafId = null;
      var vh = window.innerHeight;
      var anyVisible = false;

      state.forEach(function (s, el) {
        if (!el.isConnected) {
          state.delete(el);
          return;
        }
        var rect = el.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        anyVisible = true;

        var target = targetsFor(el);
        s.media += (target.media - s.media) * LERP;
        s.content += (target.content - s.content) * LERP;
        s.opacity += (target.opacity - s.opacity) * LERP;

        el.style.setProperty('--hero-media-offset', s.media.toFixed(2) + 'px');
        el.style.setProperty('--hero-content-offset', s.content.toFixed(2) + 'px');
        el.style.setProperty('--hero-content-opacity', s.opacity.toFixed(3));
      });

      if (anyVisible) {
        rafId = window.requestAnimationFrame(tick);
      }
    }

    function ensureLoop() {
      if (rafId === null) {
        rafId = window.requestAnimationFrame(tick);
      }
    }

    function refresh() {
      getEls().forEach(function (el) {
        if (!state.has(el)) {
          state.set(el, { media: 0, content: 0, opacity: 1 });
        }
      });
      ensureLoop();
    }

    document.addEventListener('DOMContentLoaded', refresh);
    document.addEventListener('shopify:section:load', refresh);
    window.addEventListener('scroll', ensureLoop, { passive: true });
    window.addEventListener('resize', refresh, { passive: true });

    refresh();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
